import React from "react";
import { AiOutlineDash } from "react-icons/ai";

function CircularScore({ score, staticScore, max = 10 }) {
  const totalSegments = 10;
  const activeSegments = Math.round((score / max) * totalSegments);

  return (
    <div className="flex items-center justify-center gap-2 px-2 py-1 rounded-xl border border-gray-200 bg-white w-fit">
      <div className="relative w-8 h-8 flex items-center justify-center">
        {/* Segments */}
        {[...Array(totalSegments)].map((_, i) => {
          const angle = (360 / totalSegments) * i;
          const isActive = i < activeSegments;

          return (
            <div
              key={i}
              className="absolute w-[2px] h-[6px] rounded-sm "
              style={{
                transform: `rotate(${angle}deg) translate(0, -10px)`,
                backgroundColor: isActive
                  ? score < 4
                    ? "#00C851" // green-500
                    : score < 7
                    ? "#f59e0b" // amber-500
                    : score < 9
                    ? "#E3650F" // orange-500
                    : "#ef4444" // red-500
                  : "#e5e7eb", // gray-200
              }}
            />
          );
        })}
      </div>

      {/* Score */}
      {staticScore === 0 && (
        <span className="text-sm font-medium text-neutral900">
          <AiOutlineDash />
        </span>
      )}

      {score && (
        <span className="text-sm font-medium text-neutral900">{score}</span>
      )}
    </div>
  );
}

export default CircularScore;
